export interface AppConfig {
  maintenanceMode: boolean;
  maintenanceMessage: string;
  showFunctionality?: boolean;
}

export async function fetchAppConfig(): Promise<AppConfig> {
  const res = await fetch('/app-config.json', { cache: "no-store" });
  return res.json();
}
